import { Injectable } from '@angular/core';
import {HttpService} from "../../http/http.service";
import {SolicitudRetiroIndividual} from "../../models/request/solicitud-retiro-individual";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class RadicacionSolicitudService {

  constructor(private httpService: HttpService) {
  }
  crearRadicacionSolicitudes(data: any): Observable<any> {
    return this.httpService.post(
      environment.GESTOR_SOLICITUDES.API_CLIENTE.PREFIJO_URL,
      '/solicitudes',
      data
    ).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
